import { Base, importOnInteraction, withMountWhenInView } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';

/**
 * CardWithCursor component
 */
export default class CardWithCursor extends withMountWhenInView(Base, { threshold: [0, 1] }) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'CardWithCursor',
    components: {
      Figure,
      Cursor: (app) =>
        importOnInteraction(
          () => import('../atoms/Cursor/Cursor.js'),
          'CardWithCursor',
          'mouseenter',
          app.$root
        ),
    },
  };
}
